import React, { Component } from 'react'
import { push, goBack } from 'react-router-redux';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import shortid from 'shortid'
import { parseString } from 'dxf'

import './LoginModal.css';

import Button from '../../components/Button/Button.js'
import Tabs from '../../components/Tabs/Tabs.js'
import LoginForm from '../../components/LoginForm/LoginForm.js'

import { setLoginModalOpen, pmUpdateFromHybrid } from '../../actions/actions.export.js';




class LoginModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      
    }

    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleCloseModal(){
    const { dispatch } = this.props;

    this.setState({
      currentStepIndex: 0,
      processed: false,
      baking: false
    }, (e) => {
      dispatch(setLoginModalOpen(false))      
    })
  }


  render(){
    const { dispatch, globalReducer } = this.props; 
    
    if(!globalReducer.loginModalOpen) return "";

    return <div className="modal theme-light">
      <div className="modal-bg" onClick={this.handleCloseModal}>
      </div>
      <div className="modal-inner">
        <div className="flex-split">
          <span>
            <strong>Welcome back!</strong> We missed you.
          </span>
          <span>
            <Button size="squared-normal" color="borderless" display={<i className="fal fa-times fa-lg fa-fw"/>} onClick={this.handleCloseModal}/> 
          </span>
        </div>
        <hr/>
        <LoginForm/>
      </div>
    </div>
    
  }
}
const mapStateToProps = (state) => {
  const { globalReducer } = state;

  return {
    globalReducer
  }
}

export default connect(mapStateToProps)(LoginModal);



// WEBPACK FOOTER //
// ./src/components/LoginModal/LoginModal.js